export default __webpack_public_path__ + "static/media/DayRain.f0c00ff3.mp4";